import React from "react";
import "../css/user.css";

function User({ email, name, surname, company}) {
    return (
        <div className="user">
            <p id="emailuser" className="textlink UserField"><b>Email:</b> {email}</p>
            <p id="nameuser" className="textlink UserField"><b>Name:</b> {name}</p>
            <p id="surnameuser" className="textlink UserField"><b>Surname:</b> {surname}</p>
            <p id="companyuser" className="textlink UserField"><b>Company:</b> {company}</p>
            <button type="submit" className="button buttonUser dangerbutton" onClick="">
                Delete
            </button>
        </div>
    );
}

export default User;
